module.exports = "https://cdn-assessment.mathletics.com/app/119/assets/images/5017bf9e23e5a971276b0bc94352a03f.svg";